import { useTranslation } from 'react-i18next'

import { PlayerAdminProps } from './types'
import Player from './components/player'
import MuxStudio from './components/muxStudio'
import PlayerThumb from './components/playerThumb'
import * as S from './styles'

import { Status, PlaybackStatus, Provider } from 'modules/transmission/types'

const PlayerAdmin = ({
  className,
  embedUrl,
  leadCode,
  isMuxStudioLayout,
  transmission
}: PlayerAdminProps) => {
  const { t } = useTranslation()
  const containerProps = { className }

  if (transmission.status === Status.CREATING) {
    return (
      <S.Loading
        className="_h-full _d-flex _align-items-center_justify-content-center _font-weight-bold _text-2">
        {t('transmissions.preview.creating-message')}
      </S.Loading>
    )
  }

  const isVodAvailable = transmission.playbackStatus === PlaybackStatus.DOWNLOAD_AVAILABLE
    && transmission.enableVodPlayback
  const isPlaybackNotActive = transmission.provider === Provider.HOTMART
    && transmission.playbackStatus !== PlaybackStatus.ACTIVE

  if (
    (isPlaybackNotActive && !isVodAvailable)
    || (transmission.provider === Provider.MUX_STUDIO_HOTMART && transmission.status === Status.COMPLETED)
  ) {
    return (
      <PlayerThumb
        {...containerProps}
        transmission={transmission}
        hideCountdown={transmission.status === Status.COMPLETED} />
    )
  }

  const renderContent = () => {
    if (isMuxStudioLayout) {
      return <MuxStudio muxStudioId={transmission.muxStudioId || ''} />
    }

    return <Player transmission={transmission} leadCode={leadCode} embedUrl={embedUrl} />
  }

  return (
    <S.Container {...containerProps}>
      {renderContent()}
    </S.Container>
  )
}

export default PlayerAdmin

